import { Column } from 'react-table';
import React from 'react';
import styles from './TenantsTable.css';

export const tenantsColumns = (impersonate: Function): Column<Tenant>[] => {
    return [
        {
            accessor: 'tenant',
            Header: 'Tenant Key',
            dataType: 'text',
            renderType: 'overrideCell',
            Cell: ({ value }: { value: string }) => {
                return (
                    <button className={styles.tenantButton} type='button' onClick={() => impersonate(value)}>
                        {value}
                    </button>
                );
            }
        },
        {
            accessor: 'tenantName',
            Header: 'Tenant Name',
            dataType: 'text'
        },
        {
            accessor: 'tenantAccess',
            Header: 'Allow Tenant Access',
            dataType: 'text'
        },
        {
            accessor: 'identityProviderId',
            Header: 'Identity Provider ID',
            dataType: 'text'
        },
        {
            accessor: 'description',
            Header: 'Description',
            dataType: 'text'
        }
    ];
};
